var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCreditCard(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 22,
    height: 14,
    viewBox: "0 0 22 14",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_515",
    "data-name": "Group 515",
    transform: "translate(-342 -591)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Rectangle_73",
    "data-name": "Rectangle 73",
    transform: "translate(342 595)",
    fill: "#f28d18",
    stroke: "#f18d18",
    strokeWidth: 1
  }, /*#__PURE__*/React.createElement("rect", {
    width: 22,
    height: 2,
    rx: 1,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 21,
    height: 1,
    rx: 0.5,
    fill: "none"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Rectangle_72",
    "data-name": "Rectangle 72",
    transform: "translate(342 591)",
    fill: "none",
    stroke: "#0077b6",
    strokeWidth: 1
  }, /*#__PURE__*/React.createElement("rect", {
    width: 22,
    height: 14,
    rx: 2,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 21,
    height: 13,
    rx: 1.5,
    fill: "none"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCreditCard);
export default __webpack_public_path__ + "static/media/credit_card.39ebcbdabc947b6f93c4198b2766ae57.svg";
export { ForwardRef as ReactComponent };